module.exports = __webpack_public_path__ + "static/media/EC.132a276f.png";